//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"InsetMenuDialogComments",1,0],[0,"JournalFileFormat",1,0],[0,"JournalLanguage",1,0]],[[["displayWarnings"],"SetDisplayWarnings",{},1,0]],[]];
SPLM.Preferences.SessionUserInterface = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionUserInterface";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionUserInterface.JournalFileFormatType = Object.freeze({
    "Ascii" : "Ascii", "Unicode" : "Unicode", "UnicodeBigEndian" : "UnicodeBigEndian", "Utf8" : "Utf8"});

SPLM.Preferences.SessionUserInterface.JournalLanguageType = Object.freeze({
    "VisualBasic" : "VisualBasic", "CPlusPlus" : "CPlusPlus", "Java" : "Java", "Cs" : "Cs", "Python" : "Python"});

export default SPLM;